var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"alt":"QR code","src":_vm.img_src}})
}
var staticRenderFns = []

export { render, staticRenderFns }